import style from './drawerNewCombo.module.scss';
import React, { useEffect, useState } from 'react';
import { Input, InputNumber, Button, Select, Spin, Popover } from 'antd';
import { ArrowRightOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import apiConnect from '../../../../config/apiConfig';
import {MIN_QUANTITY_VALUE, message} from '../../../utils/Utils';

const DrawerNewCombo = () => {
  const {
    containerFull,
    title,
    labelName,
    labelDescription,
    inputName,
    textarea,
    titleStands,
    layoutStand,
    container,
    bgImg,
    list,
    itemList,
    titleItem,
    propertyItem,
    btnNext,
    icon,
    selectLayout,
    labelSelect,
    labelComboType,
    inpSelect,
    inpNumber,
    labelDeadline,
    inputDeadline,
  } = style;

  const userId = localStorage.getItem('id');

  const { TextArea } = Input;
  const { Option } = Select;
  const history = useHistory();
  const [comboName, setComboName] = useState('');
  const [paymentDeadline, setPaymentDeadline] = useState('');
  const [description, setDescription] = useState('');
  const [comboQuantity, setComboQuantity] = useState(0);
  const [comboType, setComboType] = useState('abierto');
  const [idStand, setIdStand] = useState('');
  const [stands, setStands] = useState([]);
  const [standSelected, setStandSelected] = useState({});
  const [loading, setLoadgin] = useState(false);

  const [translateTpoStand] = useState({intermediate: 'Medium', full: 'Premium', standard: 'Basico'});

  useEffect(() => {
    const getStands = async () => {
      try {
        setLoadgin(true);
        const { data } = await apiConnect.get(`/users/${userId}/stands`);
        setStands(data.data);
        setLoadgin(false);
      } catch (error) {
        console.log(error); //eslint-disable-line
      }
    };

    getStands();
  }, []);

  const handleChange = (value) => {
    if (value < MIN_QUANTITY_VALUE) {
      const value = MIN_QUANTITY_VALUE;
      setComboQuantity(value);
      return;
    } else {
      setComboQuantity(value);
    }
  };

  const selectStand = (id) => {
    setIdStand(id);
    const standReset = {...standSelected};
    Object.keys(standReset).forEach((key) => {
      standReset[key] = false;
    });
    setStandSelected({...standReset, [id]: true});
  };

  const handleSubmit = () => {
    if (comboName === '') {
      message.error('El nombre del combo no puede estar vacío');
      return;
    }
    if (description === '') {
      message.error('La descripción del combo no puede estar vacía');
      return;
    }
    if (idStand === '') {
      message.error('Debe seleccionar un stand');
      return;
    }
    if (comboQuantity === 0) {
      message.error('La cantidad del combo no puede ser 0');
      return;
    }
    if (comboType === '') {
      message.error('Debe seleccionar un tipo de combo');
      return;
    }

    history.push(`/provider/mis-combos/new-combo?name=${comboName}&stand=${idStand}&description=${description}&comboQuantity=${comboQuantity}&comboType=${comboType}&action=create&paymentDeadline=${paymentDeadline}`);
  };

  return (
    <div className={containerFull}>
      <h2 className={title}>Agregar combo</h2>
      <h5 className={labelName}>Nombre del combo</h5>
      <Input
        className={inputName}
        onChange={(e) => setComboName(e.target.value)}
      />
      <h5 className={labelDescription}>Descripcion de stand</h5>
      <Popover
        content={
          <>
            <p><b>Combo abierto</b>: El combo tiene una cantidad mínima de productos.</p>
            <p><b>Combo cerrado</b>: El combo tiene una cantidad exacta de productos.</p>
          </>
        }
      >
        <h5 className={labelComboType}>
          {comboType === 'cerrado'
            ? 'Cantidad de productos'
            : 'Mínimo de productos'}{' '}
          <InfoCircleOutlined />
        </h5>
      </Popover>
      <TextArea
        className={textarea}
        onChange={(e) => setDescription(e.target.value)}
        autoSize={{ minRows: 5, maxRows: 5 }}
      />
      <h5 className={labelSelect}>Tipo de combo</h5>
      <div className={selectLayout}>
        <Select
          className={inpSelect}
          defaultValue="abierto"
          onSelect={(value) => {
            setComboType(value);
          }}
        >
          <Option value="abierto">Abierto</Option>
          <Option value="cerrado">Cerrado</Option>
        </Select>
        <InputNumber
          className={inpNumber}
          value={comboQuantity}
          onChange={(value) => handleChange(value)}
        />
      </div>
      <h5 className={labelDeadline}>Plazo de pago</h5>
      <Input
        className={inputDeadline}
        value={paymentDeadline}
        onChange={(e) => setPaymentDeadline(e.target.value)}
      />
      {console.log(standSelected)}
      <h5 className={titleStands}>Asignar stand</h5>
      {loading ? (
        <Spin />
      ) : (
        <div className={layoutStand}>
          {stands.map((stand) => (
            <div
              key={stand._id}
              className={standSelected[stand._id] ? `${container} ${style.selected}` : container}
              style={standSelected[stand._id] ? { border: '2px solid #F47E34' } : {}}
              onClick={() => selectStand(stand._id)}
            >
              <div className={bgImg} />
              <ul className={list}>
                <li className={itemList}>
                  <h5 className={titleItem}>Nombre</h5>
                  <h5 className={propertyItem}>{stand.name ? stand.name : ''}</h5>
                </li>
                <li className={itemList}>
                  <h5 className={titleItem}>Numero de stand</h5>
                  <h5 className={propertyItem}>{stand.standNumber}</h5>
                </li>
                <li className={itemList}>
                  <h5 className={titleItem}>Tipo de stand</h5>
                  <h5 className={propertyItem}>{translateTpoStand[stand.type]}</h5>
                </li>
                <li className={itemList}>
                  <h5 className={titleItem}>Hall</h5>
                  <h5 className={propertyItem}>{stand.section}</h5>
                </li>
              </ul>
            </div>
          ))}
        </div>
      )}
      <Button onClick={handleSubmit} className={btnNext}>
        Siguiente
        <ArrowRightOutlined className={icon} />
      </Button>
    </div>
  );
};

export default DrawerNewCombo;
